import { call, put, takeEvery, take } from "redux-saga/effects"
import api from "../../utilities/api"
import * as apiErrorHelpers from "../../helpers/apiErrorHelpers"
import * as sessionHelpers from "../../helpers/sessionHelpers"
import { AUTHENTICATION_TOKEN } from "../../constants/application"
import { FAILURE, SUCCESS } from "../../constants/notification"

const APPLY_PROMOTIONAL_CODE_URL = "/customers_promotions/apply"
const CUSTOMERS_PROMOTIONS_URL = "/customers_promotions"

export function* loadPromotionalCodes(action) {
  try {
    const payloadOptions = action.payload.options || {}
    // yield put({ type: "SET_LOADING" })
    yield put({ type: "UNSET_LOADING_ERROR" })

    api.setAuthApi({
      Authorization: sessionHelpers.getApplicationCookie(AUTHENTICATION_TOKEN)
    })

    ////////////////////////////
    //   LOAD VEHICLE DATA    //
    ////////////////////////////
    yield put({ type: "PROMOTIONAL_CODE_LOAD_REQUESTED" })

    let url = `/promotions/available?shopping_cart_id=${payloadOptions.shop_order_id}`

    const promotionalCodeRequest = {
      url: url,
      body: { fleet_promocode: true }
    }

    const promotionalCodeResponse = yield call(
      api.utility.get,
      api.path(promotionalCodeRequest.url),
      {
        body: promotionalCodeRequest.body
      }
    )

    apiErrorHelpers.catchErrors(promotionalCodeResponse.body)

    yield put({
      type: "PROMOTIONAL_CODE_LOAD_SUCCEEDED",
      payload: {
        promotionalCodes: promotionalCodeResponse.body
      }
    })

    if (action.callback) {
      yield call(action.callback, promotionalCodeResponse.body)
    }

    // yield put({ type: "UNSET_LOADING" })
  } catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: "PROMOTIONAL_CODE_LOAD_FAILED" })
    yield put({ type: "SET_LOADING_ERROR" })
    yield put({ type: "UNSET_LOADING" })

    apiErrorHelpers.consoleLog(errors)
  }
} // function* loadVehicle

export function* applyPromotionalCode(action) {
  try {
    const payloadOptions = action.payload.options || {}
    // yield put({ type: "SET_LOADING" })
    yield put({ type: "UNSET_LOADING_ERROR" })

    api.setAuthApi({
      Authorization: sessionHelpers.getApplicationCookie(AUTHENTICATION_TOKEN)
    })

    ////////////////////////////
    //   LOAD VEHICLE DATA    //
    ////////////////////////////
    yield put({ type: "PROMOTIONAL_CODE_APPLY_REQUESTED" })

    let body = {}

    if (payloadOptions.shop_order_id && payloadOptions.promotion_id) {
      body.shopping_cart_id = payloadOptions.shop_order_id
      body.promotion_id = payloadOptions.promotion_id
      body.fleet_promocode = true
    }

    let url = APPLY_PROMOTIONAL_CODE_URL

    const promotionalCodeRequest = {
      url: url,
      body: body
    }

    const promotionalCodeResponse = yield call(
      api.utility.post,
      api.path(promotionalCodeRequest.url),
      {
        body: promotionalCodeRequest.body
      }
    )

    apiErrorHelpers.catchErrors(promotionalCodeResponse.body)

    if (action.callback) {
      yield call(action.callback, SUCCESS, promotionalCodeResponse.body)
    }

    // yield put({ type: "UNSET_LOADING" })
  } catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: "PROMOTIONAL_CODE_APPLY_FAILED" })
    // yield put({ type: "SET_LOADING_ERROR" })
    // yield put({ type: "UNSET_LOADING" })

    const afterRequestData = {
      error: apiErrorHelpers.toString(errors)
    }

    yield call(action.callback, FAILURE, afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // function* loadVehicle

export function* createPromotionalCode(action) {
  try {
    const payloadOptions = action.payload.options || {}
    // yield put({ type: "SET_LOADING" })
    yield put({ type: "UNSET_LOADING_ERROR" })

    api.setAuthApi({
      Authorization: sessionHelpers.getApplicationCookie(AUTHENTICATION_TOKEN)
    })

    ////////////////////////////
    //   LOAD VEHICLE DATA    //
    ////////////////////////////
    yield put({ type: "PROMOTIONAL_CODE_CREATE_REQUESTED" })

    let body = {}

    if (payloadOptions.shop_order_id && payloadOptions.code) {
      body.shopping_cart_id = payloadOptions.shop_order_id
      body.code = payloadOptions.code
      body.fleet_promocode = true
    }

    let url = CUSTOMERS_PROMOTIONS_URL

    const promotionalCodeRequest = {
      url: url,
      body: body
    }

    const promotionalCodeResponse = yield call(
      api.utility.post,
      api.path(promotionalCodeRequest.url),
      {
        body: promotionalCodeRequest.body
      }
    )

    apiErrorHelpers.catchErrors(promotionalCodeResponse.body)
    apiErrorHelpers.catchErrors(promotionalCodeResponse.body)

    if (action.callback) {
      yield call(action.callback, SUCCESS, promotionalCodeResponse.body)
    }

    // yield put({ type: "UNSET_LOADING" })
  } catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: "PROMOTIONAL_CODE_CREATE_FAILED" })
    // yield put({ type: "SET_LOADING_ERROR" })
    // yield put({ type: "UNSET_LOADING" })

    const afterRequestData = {
      error: apiErrorHelpers.toString(errors)
    }

    yield call(action.callback, FAILURE, afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // function* loadVehicle

export default function* promotionalCodeSaga() {
  yield takeEvery("PROMORIONAL_CODE_LOAD_SAGA", loadPromotionalCodes)
  yield takeEvery("PROMORIONAL_CODE_APPLY_SAGA", applyPromotionalCode)
  yield takeEvery("PROMORIONAL_CODE_CREATE_SAGA", createPromotionalCode)
}
